import { Injectable  } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CryptoService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(
    private CryptoService:CryptoService
  ) {}
  setItem(key:string,value:any){
    localStorage.setItem(key,this.CryptoService.encryptAES(value))
  }
  setData(key:string,value:any){
    localStorage.setItem(key,this.CryptoService.encryptAES(JSON.stringify(value)))
  }
  getItem(key:string){
    try {
      const data = localStorage.getItem(key);
      if (!data) return null;
      return this.CryptoService.decryptAES(data);
    } catch (error) {
      this.removeItem(key)
      return null;
    }
  }
  getData(key:string){
    try {
      const data = localStorage.getItem(key);
      if (!data) return null;
      return JSON.parse(this.CryptoService.decryptAES((data as string)))
    } catch (error) {
      this.removeItem(key)
      return null;
    }
  }
  clear(){
    localStorage.clear()
  }
  removeItem(key:string){
    localStorage.removeItem(key)
  }
}